import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-our-services',
  templateUrl: './our-services.component.html',
  styleUrls: ['./our-services.component.scss']
})
export class OurServicesComponent implements OnInit {
  @Input() titleSectionProp:any;
  @Input() List:any;
  constructor(
    public translate: TranslateService,
    public route:ActivatedRoute
  ) { }

  ngOnInit(): void {
  }

}
